import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Check, Unlink, Pencil, Undo2 } from "lucide-react";
import { call } from "../url/common";

const KIND = { moved: "text-emerald-700", home: "text-amber-700", remove: "text-red-700" };

export default function FixControls({ l, onDone }) {
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState("");
  const fix = (body, ok) => call(() => api.post("/admin/links/external/fix", { url: l.url, ...body }), (x) => `${ok} on ${x.pages} page(s)`).then((r) => { if (r) { setEdit(false); onDone(); } });
  if (l.status === "fixed") {
    return (
      <div className="w-full pl-1 flex flex-wrap items-center gap-2 text-xs" data-testid="lm-fixed">
        <span className="text-emerald-700">Fixed → <span className="font-mono break-all">{l.fixed_to}</span></span>
        <Button size="sm" variant="ghost" className="h-7" onClick={() => window.confirm("Undo this fix on every page?") && call(() => api.post("/admin/links/external/undo", { url: l.url }), (x) => (x.conflicts ? `Restored ${x.restored_pages} page(s) — ${x.detail}` : `Restored ${x.restored_pages} page(s)`)).then(onDone)} data-testid="lm-fix-undo"><Undo2 size={13} className="mr-1" />Undo</Button>
      </div>);
  }
  if (l.status !== "broken") return null;
  return (
    <div className="w-full pl-1 space-y-1.5" data-testid="lm-fix-controls">
      {l.fix && <div className="text-xs"><span className={`font-semibold ${KIND[l.fix.kind]}`}>{l.fix.label}</span>{l.fix.new_url && <span className="font-mono text-slate-600 break-all"> → {l.fix.new_url}</span>}</div>}
      {edit ? (
        <div className="flex flex-wrap gap-2">
          <Input value={val} onChange={(e) => setVal(e.target.value)} placeholder="https://manufacturer.com/current-page" className="h-8 w-96 max-w-full text-xs font-mono" data-testid="lm-fix-input" />
          <Button size="sm" className="h-8 bg-steel text-white" onClick={() => fix({ action: "replace", new_url: val }, "Link replaced")} data-testid="lm-fix-save">Replace</Button>
          <Button size="sm" variant="ghost" className="h-8" onClick={() => setEdit(false)}>Cancel</Button>
        </div>
      ) : (
        <div className="flex flex-wrap gap-1.5">
          {l.fix && <Button size="sm" className="h-7 bg-emerald-600 hover:bg-emerald-700 text-white" onClick={() => fix({ action: "suggested" }, l.fix.new_url ? "Link updated" : "Link removed")} data-testid="lm-fix-apply"><Check size={13} className="mr-1" />Apply suggestion</Button>}
          <Button size="sm" variant="outline" className="h-7" onClick={() => { setVal(l.fix?.new_url || ""); setEdit(true); }} data-testid="lm-fix-edit"><Pencil size={13} className="mr-1" />Replace with…</Button>
          <Button size="sm" variant="outline" className="h-7" onClick={() => fix({ action: "remove" }, "Link removed")} data-testid="lm-fix-remove"><Unlink size={13} className="mr-1" />Remove link</Button>
        </div>)}
    </div>
  );
}
